import { render } from "./Hero.vue?vue&type=template&id=b59d7678"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
script.render = render

export default script